import { StageGoal } from './types';

export enum ProjectStage {
  PROBLEM_DEFINITION = 1,    // 问题定义：找到真实存在的用户痛点
  SOLUTION_TESTING = 2,      // 方案验证：测试解决方案的可行性
  MVP_CREATION = 3,          // MVP打造：构建最小可行产品
  LAUNCH_EXPERIMENT = 4,     // 启动实验：验证获客策略
  SCALABLE_GROWTH = 5        // 规模增长：建立可持续增长机制
}

export const STAGE_NAMES = {
  [ProjectStage.PROBLEM_DEFINITION]: "问题定义",
  [ProjectStage.SOLUTION_TESTING]: "方案验证",
  [ProjectStage.MVP_CREATION]: "MVP打造",
  [ProjectStage.LAUNCH_EXPERIMENT]: "启动实验",
  [ProjectStage.SCALABLE_GROWTH]: "规模增长"
};

export const STAGE_GOALS: Record<ProjectStage, StageGoal[]> = {
  [ProjectStage.PROBLEM_DEFINITION]: [
    {
      title: "明确用户痛点",
      description: "列出多个真实存在的用户需求痛点"
    },
    {
      title: "完成基础调研",
      description: "收集目标用户的基本信息和使用场景"
    },
    {
      title: "验证需求价值",
      description: "确认解决的问题是否值得投入资源解决"
    }
  ],
  
  [ProjectStage.SOLUTION_TESTING]: [
    {
      title: "设计解决方案",
      description: "将痛点转化为具体的解决方案构思"
    },
    {
      title: "制作概念原型",
      description: "创建可视化原型展示解决方案的核心价值"
    },
    {
      title: "收集用户反馈",
      description: "通过原型获取目标用户的改进建议"
    }
  ],
  
  [ProjectStage.MVP_CREATION]: [
    {
      title: "确定核心功能",
      description: "筛选出最能体现产品价值的必备功能"
    },
    {
      title: "完成产品开发",
      description: "使用简单工具搭建可操作的基础版本产品"
    },
    {
      title: "进行内部测试",
      description: "确保产品基本功能可用且无重大缺陷"
    }
  ],
  
  [ProjectStage.LAUNCH_EXPERIMENT]: [
    {
      title: "选择测试渠道",
      description: "确定最适合接触目标用户的推广方式"
    },
    {
      title: "准备推广素材",
      description: "制作介绍产品核心价值的宣传内容"
    },
    {
      title: "执行测试发布",
      description: "在小范围真实场景中验证产品价值"
    }
  ],

  [ProjectStage.SCALABLE_GROWTH]: [
    {
      title: "建立反馈系统",
      description: "设置收集用户意见的持续沟通渠道"
    },
    {
      title: "优化核心体验",
      description: "根据用户反馈改进产品关键功能"
    },
    {
      title: "设计增长机制",
      description: "规划让用户主动传播产品的激励方式"
    }
  ]
};

export const STAGE_DESCRIPTIONS = {
  [ProjectStage.PROBLEM_DEFINITION]: 
    "这是问题定义阶段。通过观察和调研，找到至少3个真实存在的用户痛点。" +
    "这个阶段将帮助你明确问题的普遍性和解决价值，为后续的解决方案设计和市场验证奠定基础。" +
    "关键任务包括：用户访谈、竞品分析、需求规模验证。",
  
  [ProjectStage.SOLUTION_TESTING]: 
    "这是方案验证阶段。通过制作交互原型和预售页面，测试用户对解决方案的付费意愿。" +
    "这个阶段将帮助你验证解决方案的可行性，并为后续的MVP开发提供数据支持。" +
    "关键任务包括：原型设计、预售测试、用户反馈收集。",
  
  [ProjectStage.MVP_CREATION]: 
    "这是MVP打造阶段。使用低成本工具快速构建最小可行产品，优先实现核心价值主张。" +
    "这个阶段将帮助你以最低成本验证产品市场匹配度（PMF），并为正式发布做好准备。" +
    "关键任务包括：功能优先级排序、MVP开发、内部测试。",
  
  [ProjectStage.LAUNCH_EXPERIMENT]: 
    "这是启动实验阶段。通过小范围测试市场反应，验证获客策略和用户留存率。" +
    "这个阶段将帮助你优化产品体验和运营策略，为全面发布积累经验。" +
    "关键任务包括：选择获客渠道、执行冷启动计划、收集用户数据。",
  
  [ProjectStage.SCALABLE_GROWTH]: 
    "这是规模增长阶段。通过建立自动化增长闭环和优化产品体验，实现可持续增长。" +
    "这个阶段将帮助你扩大用户规模，提升产品竞争力，并探索更多商业机会。" +
    "关键任务包括：增长策略实施、用户推荐机制设计、数据分析与迭代。"
};
